import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";
import React from "react";

export const DRONE_CARD_STYLES = {
  borderRadius: "4px",
  padding: "3px 9px",
  borderWidth: "1px",
  borderStyle: "solid",
  minWidth: "max-content",
  height: "41px",
  overflow: "hidden",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  "&:hover": { bgcolor: "grey.800" },
} as const;

export const CAROUSEL_STYLES = {
  overflowX: "auto",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  flex: 1,
} as const;

export const POPUP_BUTTON_STYLES = {
  borderRadius: "4px",
  padding: "6px 9px",
  borderWidth: "1px",
  borderStyle: "solid",
  height: "41px",
  overflow: "visible",
  cursor: "pointer",
  justifyContent: "center",
} as const;

export function ArrowBackIosTight(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 24">
      <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z" />
    </SvgIcon>
  );
}
